// Service Configuration
const CONFIG = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  backend: {
    baseUrl: import.meta.env.VITE_BACKEND_URL || 'https://messageapp-production-7516.up.railway.app',
    wsUrl: import.meta.env.VITE_WS_URL || 'https://messageapp-production-7516.up.railway.app/ws/chat',
  },
  app: {
    name: 'Chat App',
    version: '1.0.0',
    basePath: '/chat-app/',
  },
};

// Service Instances
import SupabaseAuthService from './supabaseAuth';
import ApiService from './api';
import WebSocketService from './websocket';

// Create service instances
export const authService = new SupabaseAuthService(
  CONFIG.supabase.url,
  CONFIG.supabase.anonKey
);

export const apiService = new ApiService({
  baseUrl: CONFIG.backend.baseUrl,
  timeout: 10000,
  retries: 3,
});

export const wsService = new WebSocketService(
  {
    url: CONFIG.backend.wsUrl,
    reconnectDelay: 5000,
    maxReconnectAttempts: 10,
  },
  {
    onConnect: () => console.log('🔌 WebSocket connected'),
    onDisconnect: () => console.log('🔌 WebSocket disconnected'),
    onError: (error) => console.error('🔌 WebSocket error:', error),
    onReconnect: (attempt) => console.log(`🔌 WebSocket reconnecting (attempt ${attempt})`),
  }
);

// Connect services
apiService.setAuthTokenProvider(() => authService.getAccessToken());
wsService.setAuthTokenProvider(() => authService.getAccessToken());

// Export services and config
export { 
  CONFIG,
  SupabaseAuthService,
  ApiService,
  WebSocketService,
};